import _defineProperty from "/var/app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import * as React from "react";
import { ACTIVE_SLIDE_COMPLETE, ACTIVE_SLIDE_LOADING, ACTIVE_SLIDE_PLAYING, CLASS_FLEX_CENTER, clsx, cssClass, useContainerRect, useController, useEventCallback, useEvents } from "../../core/index.js";
import { defaultVideoProps } from "./Video.js";
export var VideoSlide = function VideoSlide(_ref) {
  var slide = _ref.slide,
      offset = _ref.offset;

  var _useEvents = useEvents(),
      publish = _useEvents.publish;

  var _useContainerRect = useContainerRect(),
      setContainerRef = _useContainerRect.setContainerRef,
      containerRect = _useContainerRect.containerRect;

  var videoRef = React.useRef(null);

  var video = _objectSpread(_objectSpread({}, defaultVideoProps), useController().getLightboxProps().video);

  React.useEffect(function () {
    if (offset !== 0 && videoRef.current && !videoRef.current.paused) {
      videoRef.current.pause();
    }
  }, [offset]);
  React.useEffect(function () {
    if (offset === 0 && videoRef.current && (slide.autoPlay || video.autoPlay)) {
      publish(ACTIVE_SLIDE_LOADING);
      videoRef.current.play().catch(function () {});
    }
  }, [offset, video.autoPlay, slide.autoPlay, publish]);
  var handleVideoRef = useEventCallback(function (node) {
    if (offset === 0 && (video.autoPlay || slide.autoPlay) && node.paused) {
      node.play().catch(function () {});
    }
  });
  var setVideoRef = React.useCallback(function (node) {
    videoRef.current = node;

    if (node) {
      handleVideoRef(node);
    }
  }, [handleVideoRef]);
  var width = slide.width,
      height = slide.height,
      poster = slide.poster,
      sources = slide.sources;

  var scaleWidthAndHeight = function scaleWidthAndHeight() {
    if (!width || !height || !containerRect) return null;
    var widthBound = width / height > containerRect.width / containerRect.height;
    var elementWidth = widthBound ? containerRect.width : Math.round(containerRect.height / height * width);
    var elementHeight = !widthBound ? containerRect.height : Math.round(containerRect.width / width * height);
    return {
      width: elementWidth,
      height: elementHeight,
      style: {
        width: elementWidth,
        height: elementHeight,
        maxWidth: "100%",
        maxHeight: "100%"
      }
    };
  };

  var resolveBoolean = function resolveBoolean(attr) {
    if (slide[attr] === false) return null;
    if (slide[attr] === true) return _defineProperty({}, attr, true);
    if (video[attr] === false) return null;
    if (video[attr] === true) return _defineProperty({}, attr, true);
    return null;
  };

  var resolveString = function resolveString(attr) {
    if (video[attr] || slide[attr]) {
      return _defineProperty({}, attr, slide[attr] || video[attr]);
    }

    return null;
  };

  return React.createElement(React.Fragment, null, sources && React.createElement("div", {
    ref: setContainerRef,
    style: _objectSpread({
      width: "100%",
      height: "100%"
    }, width ? {
      maxWidth: "".concat(width, "px")
    } : null),
    className: clsx(cssClass("video_container"), cssClass(CLASS_FLEX_CENTER))
  }, containerRect && React.createElement("video", _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
    ref: setVideoRef,
    poster: poster
  }, scaleWidthAndHeight()), resolveBoolean("controls")), resolveBoolean("playsInline")), resolveBoolean("loop")), resolveBoolean("muted")), resolveBoolean("playsInline")), resolveBoolean("disablePictureInPicture")), resolveBoolean("disableRemotePlayback")), resolveString("controlsList")), resolveString("crossOrigin")), resolveString("preload")), {}, {
    onPlay: function onPlay() {
      publish(ACTIVE_SLIDE_PLAYING);
    },
    onEnded: function onEnded() {
      publish(ACTIVE_SLIDE_COMPLETE);
    }
  }), sources.map(function (_ref5, index) {
    var src = _ref5.src,
        type = _ref5.type;
    return React.createElement("source", {
      key: index,
      src: src,
      type: type
    });
  }))));
};